module.exports = __webpack_public_path__ + "static/media/timeline-pendente.ac5b0d68.svg";